<template>
  <!--
    	作者：huangyi
    	时间：2023-05-18
    	描述：组件-选择设备
    -->
  <el-dialog title="选择设备" :visible.sync="dialogVisible" @close="cancelFunc" :close-on-click-modal="false" :close-on-press-escape="false" width="800px">
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="设备号"><el-input placeholder="请输入设备号" v-model="formInline.snCode"></el-input></el-form-item>

        <el-form-item label="SN" >
          <el-input style="width: 180px;" placeholder="起始sn号" v-model="formInline.startSnCode"></el-input> ~
          <el-input style="width: 180px;" placeholder="结束sn号" v-model="formInline.endSnCode"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button icon="el-icon-search" @click="search">查询</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table :data="tableData" size="small" border style="width: 100%" v-loading="loading" @selection-change="handleSelectionChange">
          <el-table-column prop="deviceSn" label="设备号"></el-table-column>
<!--          <el-table-column prop="receiptType" label="产品名称">
            <template slot-scope="scope">
              <span v-if="scope.row.receiptType == 1" class="green">ZPOS-电签</span>
              <span v-if="scope.row.receiptType == 2" class="green">FPOS-大机</span>
              <span v-if="scope.row.receiptType == 3" class="green">ZPOS-买断版</span>
              <span v-if="scope.row.receiptType == 4" class="green">FPOS-买断版</span>
              <span v-if="scope.row.receiptType == 5" class="green">和融通</span>
              <span v-if="scope.row.receiptType == 6" class="green">合利宝</span>
              <span v-if="scope.row.receiptType == 7" class="green">电银</span>
              <span v-if="scope.row.receiptType == 8" class="green">联动支付</span>
            </template>
          </el-table-column> -->
          <el-table-column type="selection" width="45"></el-table-column>
        </el-table>
      </div>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="dialogVisible = false">取 消</el-button>
      <el-button size="small" type="primary" @click="confirmFunc">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import WifiApi from '@/api/wifi.js';
export default {
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*搜索表单对象*/
      formInline: {
        /*设备号*/
        snCode: '',
        /*产品名称*/
        receiptType: '',
        /*起始设备号*/
        startSnCode: '',
        /*结束设备号*/
        endSnCode: ''
      },
      /*会员列表*/
      tableData: [],
      /*选中的*/
      multipleSelection: [],
      /*是否显示*/
      dialogVisible: false,
      receiptTypeVisible: true
    };
  },
  props: {
    is_open: Boolean,
    is_data: Object
  },
  watch: {
    is_open: function(n, o) {
      if (n != o) {
        let self = this;
        self.dialogVisible = n;
        if (n) {
          if (self.is_data.receiptTypeList != null && self.is_data.receiptTypeList != undefined){
            self.is_data.receiptTypeList.forEach(receiptType => {
              if (receiptType == 5) {
                self.receiptTypeVisible = false;
              }
            });
          }
          self.getTableList();
        }
      }
    }
  },
  created() {

  },
  methods: {
    /*选择第几页*/
    handleCurrentChange(val) {
      this.getTableList();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.getTableList();
    },

    /*获取数据*/
    getTableList() {
      let self = this;
      console.log(this.is_data);
      self.formInline.receiptTypeList = self.is_data.receiptTypeList
      if ( self.formInline.startSnCode != null && self.formInline.startSnCode != ''){
        if (self.formInline.endSnCode == null || self.formInline.endSnCode == ''){
          this.$message.error('请填写结束设备号');
          return;
        }
      }
      if ( self.formInline.endSnCode != null && self.formInline.endSnCode != ''){
        if (self.formInline.startSnCode == null || self.formInline.startSnCode == ''){
          this.$message.error('请填写起始设备号');
          return;
        }
      }
      let params = self.formInline;
      WifiApi.noBuyDevice(params,true).then(res => {
          self.loading = false;
          self.tableData = res.data;
        })
        .catch(error => {
          self.loading = false;
        });
    },

    /*查询*/
    search() {
      this.getTableList();
    },

    /*点击确定*/
    confirmFunc() {
      let params = this.multipleSelection;
      this.emitFunc(params);
    },

    /*关闭弹窗*/
    cancelFunc(e) {
      this.emitFunc();
    },

    /*发送事件*/
    emitFunc(e) {
      this.dialogVisible = false;
      if (e && typeof e != 'undefined') {
        this.$emit('close', {
          type: 'success',
          params: e
        });
      } else {
        this.$emit('close', {
          type: 'error'
        });
      }
    },

    /*监听单选按钮选中事件*/
    selectUser(val) {
      this.multipleSelection = val;
      this.confirmFunc();
    },

    /*选择用户*/
    handleSelectionChange(e) {
      this.multipleSelection = e;
    }
  }
};
</script>

<style lang="scss" scoped>
.product-content{
  height: 50vh;
  overflow-y: auto;
}
</style>



// WEBPACK FOOTER //
// src/views/ybwifi/deviceorder/dialog/DeviceBox.vue